<template>
    <el-cascader
        size="large"
        :options="options"
        v-model="values"
        @change="change">
    </el-cascader>
</template>

<script>
import { provinceAndCityData } from 'element-china-area-data'
export default {
    name: "ProvinceSelect",
    data(){
        return{
            options: provinceAndCityData,
            values:[],
            name:''
        }
    },
    model:{
        prop:'value',
        event:'change'
    },
    props:{
        value:{
            type:Array,
            default(){
                return []
            }
        }
    },
    created() {
        this.values = this.value;
    },
    watch:{
        value(n,o){
            this.values = n;
        }
    },
    mounted() {

    },
    methods:{
        change(e){
            this.$emit("change", e);
        }
    }
}
</script>
